import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

export const BannerTopicsIconsMainWrapper = styled.section`
	min-height: 40px;
	.tab-image-wrapper {
		display: flex;
		justify-content: center;
	}

	.tabs__list {
		display: flex;
		justify-content: center;
		gap: 24px;
		width: 100%;
		overflow: auto;
		margin-bottom: 62px;
		padding: 0;
		list-style: none;
		padding-bottom: 4px;

		@media ${devices.mobile} {
			max-width: max-content;
			justify-content: flex-start;
			margin-inline: auto;
			padding: 5px 20px;
		}

		.tab__button {
			cursor: pointer;
			flex-shrink: 0;
			position: relative;
			p {
				color: #191919;
				font-weight: 400;
			}
			&.selected {
				&:after {
					content: "";
					position: absolute;
					background-color: #008060;
					width: 16px;
					height: 4px;
					border-radius: 2px;
					bottom: -4px;
					left: 50%;
					transform: translateX(-50%);
				}
				p {
					color: #008060;
					font-weight: 550;
				}
			}
		}
	}
`;

export const BannerTopicsIconsContainer = styled.div`
	&.tabs__panel {
		&.hidden {
			opacity: 0;
			pointer-events: none;
			position: absolute;
			width: 10px;
			height: 10px;
		}
	}
	.topics-icons-banner {
		position: relative;
		display: flex;
		gap: 0;
		width: 100%;
		max-width: 3500px;
		min-height: 538px;
		padding-left: 40px;
		padding-block: 10px;
		overflow: hidden;

		@media ${devices.mobile} {
			min-height: auto;
			padding-inline: 15px;
		}
	}
	.left-div {
		width: 779px;
		min-height: 538px;
		position: relative;

		@media only screen and (min-width: 1023px) and (max-width: 1140px) {
			width: 430px;
			min-height: 528px;
		}

		@media ${devices.tablet} {
			width: 379px;
			min-height: 528px;
		}

		@media ${devices.mobile} {
			display: none;
		}
	}
	.topics-icons-img {
		border-top-left-radius: var(--border-radius-md);
		border-bottom-left-radius: var(--border-radius-md);
		position: absolute;
		width: 100%;
		height: 100%;
		object-fit: cover;

		@media only screen and (min-width: 1023px) and (max-width: 1140px) {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		@media ${devices.tablet} {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.right-div {
		position: relative;
		display: flex;
		flex-direction: column;
		min-height: 538px;
		padding: 58px 66px 58px 66px;
		gap: 26px;
		right: 40px;
		background-color: #ffffff;
		border-radius: var(--border-radius-md);
		z-index: 1;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

		&.spacerDiv {
			position: relative;
			opacity: 0;
			pointer-events: none;
			width: 100%;

			@media ${devices.mobile} {
				display: none;
			}
		}

		&.showTabName {
			padding: 32px 40px 32px 40px;
		}

		@media only screen and (min-width: 2600px) {
			width: 77%;
		}

		@media only screen and (min-width: 1631px) and (max-width: 2600px) {
			width: 69%;
		}

		@media only screen and (min-width: 1141px) and (max-width: 1630px) {
			width: 60%;
		}

		@media only screen and (min-width: 1023px) and (max-width: 1140px) {
			width: 60%;
			min-height: 528px;
			padding: 32px 40px 32px 40px;
			gap: 24px;
		}

		@media ${devices.tablet} {
			width: 60%;
			min-height: 528px;
			padding: 32px 40px 32px 40px;
			gap: 24px;
		}

		@media only screen and (min-width: 766px) and (max-width: 817px) {
			min-height: 528px;
			padding: 18px 40px 18px 40px;
			gap: 10px;
		}

		@media ${devices.mobile} {
			width: 100%;
			height: auto;
			position: static;
			height: auto;
			min-height: auto;
			border-radius: 0px;
			border-radius: 0px;
			padding: var(--spacing-3x);
		}
	}
	.icon-topic-div h2 {
		font-size: var(--font-size-md);

		@media only screen and (min-width: 766px) and (max-width: 817px) {
			font-size: var(--font-size-sm);
		}
	}
	.icon-topic-div p {
		padding-left: var(--spacing-6x);
	}
	.icon-topic-div svg {
		color: #008060;
		width: 30px;
		height: 30px;
		margin-left: -7px;
	}
	.icon-topic-div > div > div:first-of-type {
		margin-top: 10px;
		width: 33px;
		height: 33px;
		border-radius: 50%;
		background: #bdd753;
	}
	.button-div {
		padding-top: var(--spacing-2x);
		align-self: flex-start;

		@media only screen and (min-width: 1023px) and (max-width: 1325px) {
			padding-top: 0px;
		}

		@media ${devices.tablet} {
			padding-top: 0px;
		}

		@media ${devices.mobile} {
			margin: 0 auto;
		}
	}
	.button-div button {
		float: right;
	}

	.hide__mobile {
		@media ${devices.mobile} {
			display: none;
		}
	}

	.slider__mobile {
		margin-bottom: 35px;
		@media ${devices.mfTablet} {
			display: none;
		}

		.icon-topic-div {
			padding-inline: 20px;
		}
	}
`;
